namespace PaperTrail.Web.Modules.NewsletterControl.Newsletter {
    export interface DownloadNewsletterRequest extends Serenity.ServiceRequest {
        FilePath?: string;
        FileName?: string;
        DeleteAfterDownload?: boolean;
        DeleteDirectoryAfterDownload?: boolean;
    }
}
